/**
 * @generated SignedSource<<50445e9e2655f8fc1afdafb9e48a0c1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditDelegatePageLazyVoterPanelQuery$variables = {
  address: string;
};
export type EditDelegatePageLazyVoterPanelQuery$data = {
  readonly delegate: {
    readonly " $fragmentSpreads": FragmentRefs<"VoterPanelFragment">;
  };
};
export type EditDelegatePageLazyVoterPanelQuery = {
  response: EditDelegatePageLazyVoterPanelQuery$data;
  variables: EditDelegatePageLazyVoterPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "address"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "address"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ResolvedName",
    "kind": "LinkedField",
    "name": "resolvedName",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessory",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "background",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "glasses",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "head",
  "storageKey": null
},
v14 = [
  (v6/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Noun",
  "kind": "LinkedField",
  "name": "nounsRepresented",
  "plural": true,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "LiquidDelegationRules",
  "kind": "LinkedField",
  "name": "rules",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionVote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionSign",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionPropose",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxRedelegations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notValidAfter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notValidBefore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customRules",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocksBeforeVoteCloses",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "TokenAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "VotingPower",
  "kind": "LinkedField",
  "name": "tokensOwned",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Noun",
  "kind": "LinkedField",
  "name": "nounsOwned",
  "plural": true,
  "selections": (v14/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDelegatePageLazyVoterPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VoterPanelFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditDelegatePageLazyVoterPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LiquidDelegationProxy",
            "kind": "LinkedField",
            "name": "liquidDelegationProxy",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateMetrics",
            "kind": "LinkedField",
            "name": "delegateMetrics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "proposalsCreated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ofLastTenProps",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "againstVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "abstainVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ofTotalProps",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OnChainProposal",
            "kind": "LinkedField",
            "name": "proposed",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "completeLiquidRepresentation",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {}
              }
            ],
            "concreteType": "LiquidDelegationRepresentation",
            "kind": "LinkedField",
            "name": "liquidRepresentation",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "proxy",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LiquidDelegationLot",
                "kind": "LinkedField",
                "name": "lots",
                "plural": true,
                "selections": [
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "liquidRepresentation(filter:{})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "tokenHoldersRepresented",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              (v4/*: any*/),
              (v20/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "delegatingTo",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "liquidDelegationProxyAddress",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiquidDelegationDelegation",
            "kind": "LinkedField",
            "name": "liquidDelegations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "to",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "totalTokensRepresented",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bpsOfDelegatedSupply",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bpsOfQuorum",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "tokensRepresented",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "currentlyActive": true
                }
              }
            ],
            "concreteType": "LiquidDelegationRepresentation",
            "kind": "LinkedField",
            "name": "liquidRepresentation",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "proxy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Noun",
                    "kind": "LinkedField",
                    "name": "nounsRepresented",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "liquidRepresentation(filter:{\"currentlyActive\":true})"
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discord",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32575a5f5fe63e3b656efb9bd1dca519",
    "id": null,
    "metadata": {},
    "name": "EditDelegatePageLazyVoterPanelQuery",
    "operationKind": "query",
    "text": "query EditDelegatePageLazyVoterPanelQuery(\n  $address: String!\n) {\n  delegate(addressOrEnsName: $address) {\n    ...VoterPanelFragment\n    id\n  }\n}\n\nfragment BlocksBeforeVoteClosesRuleFragment on LiquidDelegationRules {\n  blocksBeforeVoteCloses\n}\n\nfragment CustomRulesFragment on LiquidDelegationRules {\n  customRules\n}\n\nfragment DelegateFromListRowFragment on Delegate {\n  completeLiquidRepresentation: liquidRepresentation(filter: {}) {\n    owner {\n      address {\n        resolvedName {\n          ...NounResolvedLinkFragment\n        }\n      }\n      id\n    }\n    proxy {\n      nounsRepresented {\n        id\n        ...NounImageFragment\n      }\n      id\n    }\n    lots {\n      rules {\n        ...LiquidDelegationRulesFragment\n      }\n    }\n  }\n  tokenHoldersRepresented {\n    tokensOwned {\n      amount {\n        amount\n      }\n    }\n    address {\n      resolvedName {\n        ...NounResolvedLinkFragment\n      }\n    }\n    nounsOwned {\n      id\n      ...NounImageFragment\n    }\n    id\n  }\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  tokensRepresented {\n    amount {\n      amount\n    }\n  }\n  liquidRepresentation(filter: {currentlyActive: true}) {\n    proxy {\n      nounsRepresented {\n        __typename\n        id\n      }\n      id\n    }\n  }\n  ...NounGridFragment\n}\n\nfragment DelegatedToListRowFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n  tokensOwned {\n    amount {\n      amount\n    }\n  }\n  nounsOwned {\n    id\n    ...NounImageFragment\n  }\n  delegatingTo {\n    address {\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  liquidDelegationProxyAddress {\n    address\n  }\n  liquidDelegations {\n    to {\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    rules {\n      ...LiquidDelegationRulesFragment\n    }\n  }\n}\n\nfragment ForAgainstAbstainRowFragment on Delegate {\n  delegateMetrics {\n    forVotes\n    againstVotes\n    abstainVotes\n  }\n}\n\nfragment LiquidDelegationRulesFragment on LiquidDelegationRules {\n  ...PermissionsRuleFragment\n  ...RedelegationRuleFragment\n  ...TimeRuleFragment\n  ...CustomRulesFragment\n  ...BlocksBeforeVoteClosesRuleFragment\n}\n\nfragment NameSectionFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      name\n    }\n  }\n  liquidDelegationProxy {\n    __typename\n  }\n}\n\nfragment NounGridFragment on Delegate {\n  tokensRepresented {\n    amount {\n      amount\n    }\n  }\n  liquidRepresentation(filter: {currentlyActive: true}) {\n    proxy {\n      nounsRepresented {\n        id\n        ...NounImageFragment\n      }\n      id\n    }\n  }\n  nounsRepresented {\n    id\n    ...NounImageFragment\n  }\n}\n\nfragment NounImageFragment on Noun {\n  tokenId\n  accessory\n  background\n  body\n  glasses\n  head\n}\n\nfragment NounResolvedLinkFragment on ResolvedName {\n  address\n  name\n  ...NounResolvedNameFragment\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment PermissionsRuleFragment on LiquidDelegationRules {\n  permissionVote\n  permissionSign\n  permissionPropose\n}\n\nfragment ProposalsCreatedRowFragment on Delegate {\n  delegateMetrics {\n    proposalsCreated\n  }\n  proposed {\n    number\n    title\n    id\n  }\n}\n\nfragment ProposalsVotedRowFragment on Delegate {\n  delegateMetrics {\n    totalVotes\n    ofTotalProps\n  }\n}\n\nfragment RecentActivityRowFragment on Delegate {\n  delegateMetrics {\n    ofLastTenProps\n  }\n}\n\nfragment RedelegationRuleFragment on LiquidDelegationRules {\n  maxRedelegations\n}\n\nfragment TimeRuleFragment on LiquidDelegationRules {\n  notValidAfter\n  notValidBefore\n}\n\nfragment TotalVotePowerRowFragment on Delegate {\n  totalTokensRepresented {\n    amount {\n      amount\n    }\n  }\n}\n\nfragment VotePowerRowFragment on Delegate {\n  totalTokensRepresented {\n    bpsOfDelegatedSupply\n    bpsOfQuorum\n  }\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  liquidDelegationProxy {\n    __typename\n  }\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n\nfragment VoterPanelFragment on Delegate {\n  ...NameSectionFragment\n  ...ProposalsCreatedRowFragment\n  ...RecentActivityRowFragment\n  ...DelegateFromListRowFragment\n  ...DelegatedToListRowFragment\n  ...TotalVotePowerRowFragment\n  ...ForAgainstAbstainRowFragment\n  ...VotePowerRowFragment\n  ...ProposalsVotedRowFragment\n  ...DelegateProfileImageFragment\n  ...VoterPanelActionsFragment\n}\n"
  }
};
})();

(node as any).hash = "e2a9d05e085b84076272abc411062643";

export default node;
